import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=13ef8120&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=13ef8120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef8120",
  null
  
)

export default component.exports